import React from 'react';
import { Box, Typography, Grid, Stack, Divider, Chip } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';
import SummarizeIcon from '@mui/icons-material/Summarize';
import EventIcon from '@mui/icons-material/Event'; // Can keep or change to PaymentIcon
import HotelIcon from '@mui/icons-material/Hotel';
import HandymanIcon from '@mui/icons-material/Handyman';
import PaidIcon from '@mui/icons-material/Paid'; // New icon for payments
import GlassCard from '../../../ui/glass/components/GlassCard';

const DailySummary = ({ upcomingPayments, todaysSleepAppointments, todaysServices }) => {

    const formatTime = (timestamp) => {
        if (!timestamp) return '';
        try {
            return format(timestamp.toDate(), 'HH:mm', { locale: tr });
        } catch {
            return '';
        }
    };

    const formatDate = (timestamp) => {
        if (!timestamp) return '';
        try {
            return format(timestamp.toDate(), 'd MMM', { locale: tr });
        } catch {
            return '';
        }
    };

    return (
        <GlassCard sx={{ p: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <SummarizeIcon color="primary" />
                <Typography variant="h6">
                    Günün Özeti - {format(new Date(), 'd MMMM yyyy, EEEE', { locale: tr })}
                </Typography>
            </Box>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                        <PaidIcon color="success" />
                        <Typography variant="subtitle1" fontWeight="bold">
                            Yaklaşan Ödemeler ({upcomingPayments?.length || 0})
                        </Typography>
                    </Box>
                    <Stack spacing={1}>
                        {upcomingPayments && upcomingPayments.length > 0 ? upcomingPayments.slice(0, 5).map(pay => (
                            <GlassCard key={pay.id} sx={{ p: 1, minHeight: 'auto' }} hoverEffect={false}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography variant="body2" fontWeight="bold">{pay.musteriAdSoyad}</Typography>
                                    <Chip
                                        label={pay.tutar ? `${(pay.tutar || 0).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}` : 'Ödeme Randevusu'}
                                        size="small"
                                        color={'warning'}
                                        variant="outlined"
                                    />
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.5 }}>
                                    <Typography variant="caption" color="text.secondary">{pay.aciklama || pay.notlar || 'Ödeme Planlandı'}</Typography>
                                    <Typography variant="caption" color="text.secondary">{formatDate(pay.randevuTarihi)} {formatTime(pay.randevuTarihi)}</Typography>
                                </Box>
                            </GlassCard>
                        )) : <Typography variant="body2" color="text.secondary">Yaklaşan ödeme randevusu bulunmuyor.</Typography>}
                    </Stack>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                        <HotelIcon color="secondary" />
                        <Typography variant="subtitle1" fontWeight="bold">
                            Bugünkü Uyku Takip ({todaysSleepAppointments.length})
                        </Typography>
                    </Box>
                    <Stack spacing={1}>
                        {todaysSleepAppointments.length > 0 ? todaysSleepAppointments.slice(0, 5).map(app => (
                            <GlassCard key={app.id} sx={{ p: 1, minHeight: 'auto' }} hoverEffect={false}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography variant="body2" fontWeight="bold">{app.musteriAdSoyad}</Typography>
                                    <Chip label={formatTime(app.randevuTarihi)} size="small" color="secondary" />
                                </Box>
                                {app.hastane && <Typography variant="caption" color="text.secondary">{app.hastane}</Typography>}
                            </GlassCard>
                        )) : <Typography variant="body2" color="text.secondary">Bugün uyku takip randevusu yok.</Typography>}
                    </Stack>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                        <HandymanIcon color="primary" />
                        <Typography variant="subtitle1" fontWeight="bold">
                            Bugün Oluşturulan Servisler ({todaysServices.length})
                        </Typography>
                    </Box>
                    <Stack spacing={1}>
                        {todaysServices.length > 0 ? todaysServices.slice(0, 5).map(srv => (
                            <GlassCard
                                key={srv.id}
                                sx={{ p: 1, minHeight: 'auto' }}
                                component={RouterLink}
                                to={`/servis-kaydi/${srv.id}`}
                                style={{ textDecoration: 'none', color: 'inherit' }}
                            >
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography variant="body2" fontWeight="bold">{srv.musteriAdSoyad}</Typography>
                                    <Chip label={srv.durum} size="small" color="warning" />
                                </Box>
                                <Typography variant="caption" color="text.secondary">{srv.cihazSeriNumarasi}</Typography>
                            </GlassCard>
                        )) : <Typography variant="body2" color="text.secondary">Bugün oluşturulan servis yok.</Typography>}
                    </Stack>
                </Grid>
            </Grid>
        </GlassCard>
    );
};

export default DailySummary;
